import { create } from "zustand";

import type { GetMyProfileResponseType } from "@server/modules/users/schemas/getMyProfileSchema";

export type Role = "user" | "admin" | "superadmin";

export type SetUserPayload = Pick<
	GetMyProfileResponseType,
	"id" | "name" | "nickname" | "email" | "avatar" | "communityRating" | "role"
>;

type UserStore = {
	id: number;
	name: string;
	nickname: string;
	email: string;
	avatar: string;
	communityRating: number;
	role: Role;

	isLoggedIn: boolean;
	isLoading: boolean;
	hasFriendRequests: boolean;

	setUser: (user: SetUserPayload) => void;
	resetUser: () => void;
	setName: (name: string) => void;
	setNickname: (nickname: string) => void;
	setEmail: (email: string) => void;
	setAvatar: (avatar: string) => void;
	setCommunityRating: (communityRating: number) => void;
	setIsLoggedIn: (isLoggedIn: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
	setHasFriendRequests: (hasFriendRequests: boolean) => void;
};

const initialState = {
	id: 0,
	name: "",
	nickname: "",
	avatar: "",
	email: "",
	role: "user" as Role,
	communityRating: 70,
	isLoggedIn: false,
	isLoading: true,
	hasFriendRequests: false,
};

export const useUserStore = create<UserStore>((set) => ({
	...initialState,

	setUser: (user) =>
		set({
			id: user.id,
			name: user.name,
			nickname: user.nickname,
			email: user.email,
			avatar: user.avatar,
			communityRating: user.communityRating,
			role: user.role,
		}),
	resetUser: () => set(initialState),
	setName: (name) => set({ name }),
	setNickname: (nickname) => set({ nickname }),
	setEmail: (email) => set({ email }),
	setAvatar: (avatar) => set({ avatar }),
	setCommunityRating: (communityRating) => set({ communityRating }),
	setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
	setIsLoading: (isLoading) => set({ isLoading }),
	setHasFriendRequests: (hasFriendRequests) => set({ hasFriendRequests }),
}));
